import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large FeedBacksActions",
    title: "Смена статуса отклика",
    "confirm-button-text": "Подтвердить",
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitChangeStatus
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        value: _ctx.state.status_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.status_id) = $event)),
        placeholder: "Статус",
        "is-invalid": _ctx.state_form$.status.$error,
        "validation-errors": _ctx.state_form$.status.$errors,
        loading: false,
        options: _ctx.FeedbackStatuses,
        "search-by": "name",
        "select-by": "id",
        label: "name"
      }, null, 8, ["value", "is-invalid", "validation-errors", "options"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}